// The face of the gym. To use a real portrait, put the image in frontend/public
// (for example coach.jpg) and change photo to "/coach.jpg".
export const COACH = {
  name: "OCTON Coach",
  photo: "/octon-icon.png",
  intro: "I plan every class around how the group is training and recovering, and I remember how each of you moves.",
};
